import type { FC } from "react";
import { SharingOption } from "app/components/sharingAssetModal/components/sharingStateRadioOptions/SharingOption";
import type { IAccountText } from "app/components/sharingAssetModal/types";
import { ESharingState } from "app/components/sharingAssetModal/types";
import type { ISharingType } from "app/components/sharingAssetModal/components/sharingStateRadioOptions/types";

interface IAccount extends ISharingType {
    text: IAccountText;
}

export const Account: FC<IAccount> = (props) => {
    const { sharingState, setSharingState, text, isDisabled } = props;
    const { title, subtitle } = text;
    return (
        <SharingOption
            onClick={() => setSharingState(ESharingState.ACCOUNT)}
            isSelected={sharingState === ESharingState.ACCOUNT}
            iconName={"company"}
            title={title}
            subTitle={subtitle}
            isDisabled={isDisabled}
        />
    );
};
